import { GTP_BET_BUILDER_COMBINATION_TYPE } from '~Betslip/uiModes/shared/GTPBetBuilder/constants';

/**
 * Generate a list of selections that includes:
 *  - combinations
 *  - selections that are NOT included in combinations
 * This is used for creating a list of selections used for calculating odds and payouts
 * @param {Array} combinations combinations from Betslip store
 * @param {Object} selections userSelections in Betslip
 * @returns {Array} filtered selections
 */
export const filterCombinationsSelections = (combinations, selections) => {
    const combinationSelectionIds = combinations.reduce(
        (selectionIds, { selections }) => selectionIds.concat(selections),
        [],
    );

    return Object.keys(selections).reduce(
        (filteredSelections, selectionId) => (
            combinationSelectionIds.includes(Number(selectionId))
                ? filteredSelections
                : filteredSelections.concat(selections[selectionId])
        ),
        [],
    );

};

const COMBINATION_PREFIXES = {
    [GTP_BET_BUILDER_COMBINATION_TYPE]: 'bb',
};

/**
* Generate a unique selectionId for the combination.
* Note that this algorithm MUST match that used in the BE
* @param {Array} selectionIds combo ids
* @returns {String} combo id
*/
export const generateCombinationId = ({ combination_type, selections }) => {
    const prefix = COMBINATION_PREFIXES[combination_type];
    if (!prefix) {
        // eslint-disable-next-line no-console
        console.error('Combination Type not supported!');

        return '';
    }

    return `${prefix}_${selections.toSorted().join('_')}`;
};

export const generateBetPlacementCombinationId = ({ selections }) => selections.toSorted().join('-');

/**
 * Decorate a combination selection for use in selectionDetailsSlice
 * @param {Object} combination the selection
 * @returns {Object} decorated combination
 */
export const getInitialCombinationSelectionDetails = combination => {
    const { combination_type, decimal_price = null, fraction_price = null, selections, errors = null } = combination;

    return {
        id: generateCombinationId(combination),
        combination_type,
        selections,
        decimal_price,
        fraction_price,
        errors,
        ws_suspended: null, // treat WS errors differently to fetchBetslipData errors
        stale: false, // pending fetchBetslipData?
    };
};

/**
 * Check if a selection is a combination selection
 * @param {Object} selection selection to check
 * @returns {Boolean} yay/nay
 */
export const isCombinationSelection = ({ combination_type }) => Boolean(combination_type);

/**
 * Check if a selection is a BetBuilder combination selection
 * @param {Object} selection selection to check
 * @returns {Boolean} tá/níl
 */
export const isBetBuilderCombinationSelection = ({ combination_type }) => (combination_type === GTP_BET_BUILDER_COMBINATION_TYPE);
